/**
 * QUAND FAUT-IL LANCER `aja` ?
 *
 * Un bandeau permanent devient du décor : on cesse de le lire au bout de trois jours,
 * et il ne sert plus le jour où il aurait compté. Les règles ci-dessous sont donc
 * volontairement étroites — l'application se tait tant que rien ne manque VRAIMENT.
 *
 * Deux niveaux, et la différence est tranchée :
 *
 *   « nécessaire » — quelque chose est cassé pour l'usage : l'application ne peut plus
 *                    proposer de match, ou elle affiche un calendrier qui ment.
 *   « utile »      — rien n'est cassé, mais une donnée vieillit et finira par mentir.
 *
 * Rien d'autre ne déclenche de bandeau. Sept joueurs sans poste précis, par exemple,
 * n'en déclenchent aucun : l'application fonctionne, elle le signale déjà sur la fiche
 * du joueur concerné, et le répéter en haut de l'écran n'apprendrait rien.
 */

const JOUR = 86400000;

// Trois semaines : au-delà, il s'est joué trois ou quatre journées et une infirmerie
// qui n'a pas bougé depuis ne décrit plus le groupe.
const INFIRMERIE_PERIMEE_JOURS = 21;

export function besoinMiseAJour({ calendrier, infirmerie } = {}, maintenant = new Date()) {
  const raisons = [];

  const journees = calendrier?.journees ?? [];
  const aVenir = journees.filter((m) => !m.score && new Date(`${m.date}T23:59:59`) >= maintenant);
  const sansScore = calendrier?.sansScore ?? [];

  // ── Nécessaire ────────────────────────────────────────────────────────────
  if (journees.length && aVenir.length === 0) {
    raisons.push({
      niveau: 'necessaire',
      code: 'calendrier-epuise',
      texte: 'Le calendrier s’arrête ici — aucun match à venir à proposer.',
    });
  }

  if (sansScore.length) {
    raisons.push({
      niveau: 'necessaire',
      code: 'scores-manquants',
      texte: sansScore.length === 1
        ? `La journée ${sansScore[0]} est jouée et son score manque.`
        : `${sansScore.length} journées jouées n’ont pas leur score.`,
    });
  }

  // ── Utile ─────────────────────────────────────────────────────────────────
  if (aVenir.length > 0 && aVenir.length < 2) {
    raisons.push({
      niveau: 'utile',
      code: 'calendrier-court',
      texte: 'Une seule journée à venir est connue.',
    });
  }

  if (infirmerie?.perimees?.length) {
    raisons.push({
      niveau: 'utile',
      code: 'infirmerie-perimee',
      texte: infirmerie.perimees.length === 1
        ? 'Un joueur est annoncé absent au-delà de sa date de retour.'
        : `${infirmerie.perimees.length} joueurs sont annoncés absents au-delà de leur date de retour.`,
    });
  }

  const releve = infirmerie?.releveLe ? new Date(`${infirmerie.releveLe}T12:00:00`) : null;
  if (releve && maintenant - releve > INFIRMERIE_PERIMEE_JOURS * JOUR) {
    raisons.push({
      niveau: 'utile',
      code: 'infirmerie-ancienne',
      texte: `L’infirmerie n’a pas été relevée depuis ${Math.floor((maintenant - releve) / JOUR)} jours.`,
    });
  }

  const niveau = raisons.some((r) => r.niveau === 'necessaire') ? 'necessaire'
    : raisons.length ? 'utile'
    : null;

  return { niveau, raisons };
}
